//import SearchArea from "@/pages/comp/basic/student/list/area/search/search_area";
import search_ico from "@/img/ico/search3.png";
import search_ico4 from "@/img/ico/search4.png";
import search_ico2 from "@/img/ico/search2.png";
import SearchLectureSelect from "@/pcomponents/common/content/basic/student/search/search_lecture_select";
import MyScreenFunc from '@/pcomponents/common/screen/func/screen_func';
import XcolumnFunc from '@/pcomponents/common/xcolumn/xcolumn/xcolumn_func';

const SearchArea = (props: any) => {
  let myProps = {
    listOpt: {},
    setListOpt: (inData: any) => { },
    list: (inData: any) => { },
    is_show_add_btn: false,
    add_btn_text: "+",
    on_click_go_add: () => { },
    sub_right_text: "",
    title_right_top_area: "",
    right_top_area_style: {},
    search_line_right_text: "",
    ...props
  };
  let listOpt = myProps.listOpt;
  if (listOpt["s_attend_sort_detail"] === undefined) {
    listOpt["s_attend_sort_detail"] = "";
  }
  let select_attend_s_detail_arr = [
    { value: "", text: "출석" },
    { value: "attend", text: "등원" },
    { value: "late", text: "지각" },
    { value: "absent", text: "결석" },
    { value: "empty", text: "미등원" },
  ];
  let is_under_width = MyScreenFunc.get_is_under();
  let select_a_stu_grade_option_arr = XcolumnFunc.getSortByTableKey({ 'table': 'user', 'key': 'a_stu_grade' });
  let select_a_stu_state_option_arr = XcolumnFunc.getSortByTableKey({ 'table': 'user', 'key': 'a_stu_state' });

  const handleInputChange = (event: any) => {
    const target = event.target;
    let value = target.value;
    const name = target.name;
    if (target.type === 'checkbox' || target.type === 'radio') {
      value = "";
      if (target.checked) {
        value = target.value;
      }
    }
    let change_list_opt: any = {
      ...listOpt,
      [name]: value,
      now_page: 1
    };
    if (name == "s_stu_state") {
      if (value == "rest"||value == "end") {
        change_list_opt["order_id"] = "a_stu_end_date DESC, a_stu_grade, a_user_name";
      }
    }

    if (target.tagName.toLowerCase() === "select"
      || target.type === "checkbox" || target.type === "radio") {
      myProps.list(change_list_opt);
    } else {
      myProps.setListOpt(change_list_opt);
    }
  };

  let search_ico_src = search_ico;
  //if (location.hostname == "dalirant.planiedu.com") {
  search_ico_src = search_ico4;
  //}

  let right_top_area_style: any = {
    position: "absolute", display: "inline-block",
    right: 0, textAlign: "right", top: "-30px", minHeight: "30px", lineHeight: "21px",
    ...myProps.right_top_area_style
  };
  if (is_under_width) {
    right_top_area_style["position"] = "relative";
    right_top_area_style["top"] = "0px";
    right_top_area_style["right"] = "0px";
    right_top_area_style["display"] = "none";
  }

  return (
    <div className="basic_search_wrap">
      <div className="basic_search_title_bar">
        학생검색
        <span className="ml-1"
          style={{ fontSize: "13px", color: "#777", fontWeight: "normal" }}>{myProps.sub_right_text}</span>
      </div>
      <div className="basic_search_box_wrap">
        <div className="basic_search_item_input_wrap" >
          <input type="text" className="search_item_input" name="s_user_name_like"
            value={listOpt.s_user_name_like} onChange={handleInputChange} placeholder="이름" autoComplete="off"
            onKeyUp={(e: any) => {
              if (e.key === "Enter") {
                myProps.list({ now_page: 1 });
              }
            }}
          />
        </div>
        <div className="basic_search_item_input_wrap" >
          <input type="text" className="search_item_input" name="s_school_name_like"
            value={listOpt.s_school_name_like} onChange={handleInputChange} placeholder="학교" autoComplete="off"
            onKeyUp={(e: any) => {
              if (e.key === "Enter") {
                myProps.list({ now_page: 1 });
              }
            }}
          />
        </div>
        <div className="basic_search_item_input_wrap" >
          <SearchLectureSelect
            name="s_stu_lecture_seq"
            value={listOpt.s_stu_lecture_seq}
            class_name="search_item_input_select"
            on_change_input={(inData: any) => {
              let name = inData.name;
              let value = inData.value;
              myProps.list({ now_page: 1, [name]: value });
            }}
            wrap_class_name="search_item_input_select"
            wrap_style={{ padding: "0px", border: 0 }}
          ></SearchLectureSelect>
        </div>
        <div className="basic_search_item_input_wrap" >
          <select className="search_item_input_select" name="s_stu_grade" value={listOpt.s_stu_grade} onChange={handleInputChange}>
            <option value="">학년</option>
            <option value="baby">미취학</option>
            <option value="elementary">초</option>
            <option value="middle">중</option>
            <option value="high">고</option>
            {
              select_a_stu_grade_option_arr.map((item: any, idx: number) => {
                if (item.value < 8) {
                  return "";
                }
                return (
                  <option value={item.value} key={idx}>{item.text}</option>
                );
              })
            }
          </select>
        </div>
        <div className="basic_search_item_input_wrap" >
          <select className="search_item_input_select" name="s_attend_sort_detail" value={listOpt.s_attend_sort_detail} onChange={handleInputChange} >
            {
              select_attend_s_detail_arr.map((item: any, idx: number) => {
                return (
                  <option value={item.value} key={idx}>{item.text}</option>
                );
              })
            }
          </select>
        </div>
        <div className="basic_search_item_input_wrap" >
          <select className="search_item_input_select" name="s_stu_state" value={listOpt.s_stu_state} onChange={handleInputChange} >
            <option value="">전체</option>
            <option value="now,ready">대기,재원</option>
            {
              select_a_stu_state_option_arr.map((item: any, idx: number) => {
                return (
                  <option value={item.value} key={idx}>{item.text}</option>
                );
              })
            }
          </select>
        </div>
        <div className="basic_search_item_input_wrap">
          <button className="btn-l btn-yellowish2" onClick={() => { myProps.list({ now_page: 1 }); }} style={{ padding: "6px" }}>
            <img src={search_ico2} style={{ maxHeight: 25, minWidth: 20 }} />
          </button>
          <div style={right_top_area_style}>
            {myProps.title_right_top_area}
          </div>
        </div>
        {myProps.is_show_add_btn &&
          <button className="btn-l btn-yellowish2 ml-2" onClick={myProps.on_click_go_add}
            style={{ fontSize: "30px", borderRadius: "15px", padding: "0px 12px", paddingBottom: "4px", lineHeight: "35px" }}>
            {myProps.add_btn_text}
          </button>
        }
        {myProps.search_line_right_text}
      </div>
      {props.children}
    </div>
  );
};

export default SearchArea;